import { injectable, inject } from 'inversify';
import { CommandHandler, createCommand } from '@/app/tracking/api';
import { EarnBadgesCommand, EarnBadgesCommandPayload } from '../api';
import { BadgeSuspendDataStateStore } from './badge-suspend-data-state-store';
import { UpdateBadgesStateCommandPayload, UpdateBadgesStateCommand } from './update-badges-state-command';

@injectable()
export class EarnBadgesCommandHandler implements CommandHandler<EarnBadgesCommand> {

  constructor(
    @inject(BadgeSuspendDataStateStore)
    private readonly store: BadgeSuspendDataStateStore) {
  }

  public async execute(payload: EarnBadgesCommandPayload) {

    const items: UpdateBadgesStateCommandPayload = payload.map((x) => ({
      id: x.id,
      status: 'earned',
      date: x.date
    }));

    await this.store.execute(createCommand<UpdateBadgesStateCommand>('update-badges-state', items));
  }
}
